import { Navigate } from 'react-router-dom';
import { NoAccess, firstAllowedArea, usePermissions } from '../platform/auth/permissions';

/** Entrada do portal: a primeira área que a pessoa pode abrir. */
export function HomeRedirect() {
  const { ready, can } = usePermissions();
  if (!ready) return null;
  const target = firstAllowedArea(can);
  return target ? <Navigate to={target} replace /> : <NoAccess />;
}
